import { AnyAaaaRecord } from "dns";
import { userInfo } from "os";
import { BASE_API_URL } from "config/configUrl";
import { getPermissionsFromRoles } from "@react-admin/ra-rbac";
import { canAccess } from "@react-admin/ra-rbac";
import { roleDefinitions, permissionLevels } from "./roles";
import { checkSession } from "./checkSession";

export const getAccessToken = () => {
  const auth = JSON.parse(localStorage.getItem('auth') || '{}');
  return auth?.access_token || '';
};
const authProvider = {
  login: async ({ username, password }: any) => {
    try {
      let formLogin = {
        email: username,
        password: password,
      };

      const request = new Request(`${BASE_API_URL}/auth/login`, {
        method: "POST",
        credentials: 'include',
        body: JSON.stringify(formLogin),
        headers: new Headers({ "Content-Type": "application/json" }),
      });
      const response = await fetch(request);
      if (response.status < 200 || response.status >= 300) {
        const error = await response.json();
        throw new Error(error.message);
      }
      const auth = await response.json();
      localStorage.setItem("auth", JSON.stringify(auth));

    } catch (err) {
      return Promise.reject(err);
    }
  },
  checkAuth: async (params: any=null) => {

    const isValid = await checkSession();
    return isValid
      ? Promise.resolve()
      : Promise.reject({ redirectTo: "/login" });
  },

  getPermissions: async () => {
    try {
      const currentPath = window.location.pathname;
      const excludedPaths = ['/login', '/register', '/forgot-password', '/reset-password', '/recover-password'];
      
      if (excludedPaths.includes(currentPath)) {
        return Promise.resolve([]);
      }
      await authProvider.checkAuth();
      const requestUser = new Request(`${BASE_API_URL}/users/personnal`, {
        method: "GET",
        credentials: 'include',
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        }),
      });
      const responseUser = await fetch(requestUser);
      if (responseUser.status < 200 || responseUser.status >= 300) {
        throw new Error(responseUser.statusText);
      }
      const { permissionLevel } = await responseUser.json();
      const userRole = permissionLevels[permissionLevel].toLowerCase();
      const permissions = getPermissionsFromRoles({
        roleDefinitions,
        userRoles: [userRole],
      });
      localStorage.setItem("permissions", JSON.stringify(permissions));
      return Promise.resolve(permissions);
    } catch (err) {
      return Promise.reject(err);
    }
  },
  getIdentity: async () => {
    try {
      await authProvider.checkAuth();
      const request = new Request(`${BASE_API_URL}/users/personnal`, {
        method: "GET",
        credentials: 'include',
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        }),
      });

      const response = await fetch(request);
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }
      const responseJson = await response.json();
      return Promise.resolve(responseJson);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  checkError: (error: any) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      //localStorage.removeItem("auth");
      return Promise.reject();
    }
    // other error code (404, 500, etc): no need to log out
    return Promise.resolve();
  },
  logout: () => {
    localStorage.removeItem("auth");
    return Promise.resolve();
  },
  canAccess: async ({ resource, action, record }) => {
    const permissions = JSON.parse(localStorage.getItem("permissions"));
    return canAccess({ permissions, resource, action, record });
  },
  // ...
};

export interface UserIdentity {
  id: Identifier;
  fullName?: string;
  avatar?: string;
  [key: string]: any;
}
export type Identifier = string | number;

export default authProvider;
